import React from "react";
import Moment from "moment";

import {
  Content
} from "@patternfly/react-core";

import {
  Table,
  Tbody,
  Tr,
  Td,
} from "@patternfly/react-table";

import pfPackage from "@patternfly/react-core/package.json";
import reactPackage from "react/package.json";

import AvatarSvg from "./AvatarSvg";
import VersionStatus from "./VersionStatus";

export default function UserProfileCard({
  userProfile,
  systemInfo,
}) {
  const packages = [
    {
      name: "Django",
      current: systemInfo?.django_version,
      latest: systemInfo?.django_last_version,
    },
    {
      name: "Python",
      current: systemInfo?.python_version,
      latest: systemInfo?.python_last_version,
    },
    {
      name: "React",
      current: reactPackage.version,
      latest: systemInfo?.react_last_version,
    },
    {
      name: "PatternFly",
      current: pfPackage.version,
      latest: systemInfo?.patternfly_last_version,
    },
  ];

  const chunkArray = (arr, size) => {
    const result = [];

    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  };

  const initials =
    userProfile.first_name
      ? `${userProfile.first_name.charAt(0).toUpperCase()}${userProfile.last_name.charAt(0).toUpperCase()}`
      : `${userProfile.username?.charAt(0)?.toUpperCase() ?? ""}${userProfile.username?.charAt(1)?.toUpperCase() ?? ""}`;

  return (
    <div style={{ textAlign: "center" }}>
      {userProfile.username && (
        <Content>{userProfile.username}</Content>
      )}

      {userProfile.email && (
        <Content>{userProfile.email}</Content>
      )}

      <br />

      <AvatarSvg initials={initials} />

      <br />

      <Content>
        Witaj,{" "}
        {userProfile.first_name
          ? `${userProfile.first_name} ${userProfile.last_name}`
          : userProfile.username}
      </Content>

      <br />

      <Table
        aria-label="User info"
        variant="compact"
        borders="compactBorderless"
      >
        <Tbody>

          {userProfile.is_superuser &&
            systemInfo?.django_version &&

            chunkArray(packages, 2).map(
              (row, idx) => (
                <Tr key={idx}>
                  <Td>
                    {row[0] && (
                      <VersionStatus
                        pkg={row[0]}
                      />
                    )}
                  </Td>

                  <Td>
                    {row[1] && (
                      <VersionStatus
                        pkg={row[1]}
                      />
                    )}
                  </Td>

                  <Td />
                </Tr>
              )
            )}

          {userProfile.is_superuser && Moment(
            userProfile.last_login
          ).isValid() && (
            <Tr>
              <Td>
                <small>
                  <b>Last login:</b>
                </small>
              </Td>

              <Td>
                <small>
                  {Moment(
                    userProfile.last_login
                  ).format(
                    "DD.MM.YYYY"
                  )}
                </small>
              </Td>

              <Td>
                <small>
                  {Moment(
                    userProfile.last_login
                  ).format(
                    "H:mm a"
                  )}
                </small>
              </Td>
            </Tr>
          )}

          <Tr>
            <Td>
              <small>
                <b>Joined:</b>
              </small>
            </Td>

            <Td>
              <small>
                {Moment(
                  userProfile.date_joined
                ).format(
                  "DD.MM.YYYY"
                )}
              </small>
            </Td>

            <Td>
              <small>
                {Moment(
                  userProfile.date_joined
                ).format(
                  "H:mm a"
                )}
              </small>
            </Td>
          </Tr>

        </Tbody>
      </Table>
    </div>
  );
}